export const ALL_CATEGORIES = "All";

/**
 * Category tabs for the menu panel.
 *
 * These used to come from the demo seed in data/posData. A restaurant whose
 * categories are not "Starters / Mains / Breads" got tabs that matched nothing,
 * so tapping one emptied the grid and the item was unreachable mid-rush.
 * Derived from the loaded menu, so the tabs always match what is on screen.
 */
export const menuCategories = menu => [
  ALL_CATEGORIES,
  ...Array.from(new Set((menu || []).map(item => item.category).filter(Boolean))).sort(),
];

/**
 * Filter by category tab and the search box.
 *
 * Search matches name or short code, case-insensitively — a captain types "pt" for
 * Paneer Tikka. Whitespace is trimmed because a trailing space from a tablet
 * keyboard's autocomplete would otherwise hide every result.
 */
export const filterMenuItems = (menu, category, search) => {
  const needle = String(search || "").trim().toLowerCase();
  return (menu || []).filter(item => {
    if (category && category !== ALL_CATEGORIES && item.category !== category) return false;
    if (!needle) return true;
    return `${item.name || ""} ${item.code || ""}`.toLowerCase().includes(needle);
  });
};
